import { render } from "./HeaderedPage.vue?vue&type=template&id=c94b67ba&scoped=true"
import script from "./HeaderedPage.vue?vue&type=script&lang=js"
export * from "./HeaderedPage.vue?vue&type=script&lang=js"

import "./HeaderedPage.vue?vue&type=style&index=0&id=c94b67ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94b67ba"]])

export default __exports__